import { createIndexedDBFromSchema } from "./createIndex";
import { fileSchema, version } from "./schema";

const fileDB = createIndexedDBFromSchema(fileSchema, version);
export default fileDB;
